module.exports = __webpack_public_path__ + "img/prize-fsc-light.13fffbfa.png";